import React from 'react';
import Currency from '../../../../helpers/currency';

const CheckoutBatterieDeposit = ({ product }) => {

    if (!product) return null;

    return (
        <div className="batterie">
            <div className='uk-flex batterie-wrapper'>
                <div className='batterie_name'>
                    <b>
                        Batteriepfand:
                    </b>
                </div>
                <div className='uk-flex batterie_price uk-width-1-1'>
                    <div className='batterie_price_text uk-width-1-1'>
                        <span> Batteriepfand lt. §10 BattG.</span>
                        <span> Menge {product.quantity}</span>
                    </div>
                    <div className='uk-text-right uk-width-1-2'>
                        <Currency quantity={product.batterieDeposit * product.quantity} />
                    </div>
                </div>

            </div>
        </div>
    );

};

export default CheckoutBatterieDeposit;